import { defineAsyncComponent } from 'vue'
import { CciDataSource, CciDataSourceClearMemory, sections, articles, ads, pages, singlePages, interstitials, stylesheetRef } from 'model/CciDataSource.js'
import { mapGetters } from 'vuex'
import { IssueData } from 'issueData'

import CciNavigationBar from 'components/ccinavigationbar/CciNavigationBar.vue'
import CciSectionsBar from 'components/ccisectionsbar/CciSectionsBar.vue'
// const CciNavigationBar = defineAsyncComponent(() => import(/* webpackChunkName: 'NavigationBar' */ 'components/ccinavigationbar/CciNavigationBar.vue'))
// const CciSectionsBar = defineAsyncComponent(() => import(/* webpackChunkName: 'SectionsBar' */ 'components/ccisectionsbar/CciSectionsBar.vue'))
const CciScrubber = defineAsyncComponent(() => import(/* webpackChunkName: 'Scrubber' */ 'components/cciscrubber/CciScrubber.vue'))
const CciIssueOverview = defineAsyncComponent(() => import(/* webpackChunkName: 'IssueOverview' */ 'components/cciissueoverview/CciIssueOverview.vue'))
const CciArticleModal = defineAsyncComponent(() => import(/* webpackChunkName: 'ArticleModal' */ 'components/cciarticlemodal/CciArticleModal.vue'))
const CciSocialSharing = defineAsyncComponent(() => import(/* webpackChunkName: 'SocialSharing' */ 'components/ccisocialsharing/CciSocialSharing.vue'))
const CciImageGalleryModal = defineAsyncComponent(() => import(/* webpackChunkName: 'ImageGalleryModal' */ 'components/cciimagegallerymodal/CciImageGalleryModal.vue'))
const CciRightAlignedNavigationBar = defineAsyncComponent(() => import(/* webpackChunkName: 'RightAlignedNavigationBar' */ 'components/ccirightalignednavigationbar/CciRightAlignedNavigationBar.vue'))
const CciLeftAlignedScrubber = defineAsyncComponent(() => import(/* webpackChunkName: 'LeftAlignedScrubber' */ 'components/ccileftalignedscrubber/CciLeftAlignedScrubber.vue'))
const CciGoogleAdBottomMobile = defineAsyncComponent(() => import(/* webpackChunkName: 'GoogleAdBottomMobile' */ 'components/ccigoogleads/CciGoogleAdBottomMobile.vue'))
const CciGoogleAdSide = defineAsyncComponent(() => import(/* webpackChunkName: 'GoogleAdSide' */ 'components/ccigoogleads/CciGoogleAdSide.vue'))

export default {
  name: 'webreader',
  data () {
    return {
      isZoomed: false
    }
  },
  created () {
    // add click event listener to webreader app to close navigations
    document.getElementById('webreader-app').addEventListener('click', this.closeNavigations)
    this.loadStartRoute()

    const cciobjectsUrl = this.$opsURL + 'cciobjects.json'

    let urlGETFullIssue = this.$opsURL
    urlGETFullIssue = urlGETFullIssue.substr(0, urlGETFullIssue.lastIndexOf('/'))
    urlGETFullIssue = urlGETFullIssue.substr(0, urlGETFullIssue.lastIndexOf('/'))

    this.requestUrlTest(urlGETFullIssue + '/pagespdffull').then((isValid) => {
      this.$store.state.hasGETFullIssue = isValid
    })

    this.requestUrlTest(this.getAudioMp3UrlEndpoint(), true).then((isValid) => {
      this.$store.state.hasTtsService = isValid
    })

    fetch(cciobjectsUrl).then((response) => {
      if (!response.ok) {
        throw new Error(response.status + ' - Network response was not ok. ' + response.statusText + ' Please try again later')
      }
      return response.json()
    }).then(data => {
      const json = data
      this.$store.commit('setPageViewMode', this.$readerOptions.isFullPageViewMode)      
      this.$store.commit('setArticleViewMode', this.$readerOptions.articleViewModeDefault)
      this.$store.commit('setIsInSinglePagesMode', this.$readerOptions.singlePagesModeDefault)

      let locIssueData = {}
      locIssueData.gptAdsEnabled = this.$readerOptions.gptAdCode !== undefined && this.$readerOptions.gptAdCode !== ''

      let isSinglePages = this.isPhone || (this.isTabletPortrait && !locIssueData.gptAdsEnabled) || this.isPortrait || this.$readerOptions.singlePagesModeDefault
      
      CciDataSource(json, isSinglePages, this.$readerOptions)

      locIssueData.publicationName = json.attributes.DigitalPublicationName !== undefined && json.attributes.DigitalPublicationName !== '' ? json.attributes.DigitalPublicationName : json.attributes.ProductNameCont
      locIssueData.pubDateDate = json.attributes.PubDateDate
      locIssueData.zoneCont = json.attributes.ZoneCont
      locIssueData.editionCont = json.attributes.EditionCont
      locIssueData.issueInternalId = json.id
      locIssueData.issueInternalName = json.attributes.Name
      locIssueData.issueName = json.attributes.DigitalIssueName !== undefined && json.attributes.DigitalIssueName !== '' ? json.attributes.DigitalIssueName : json.attributes.PubDateCont
      locIssueData.interstitialsFrequency = json.attributes.InterstitialsFrequency !== undefined && json.attributes.InterstitialsFrequency !== '' ? parseInt(json.attributes.InterstitialsFrequency) : 3
      locIssueData.isSinglePages = json.attributes.IsSinglePages !== undefined && json.attributes.IsSinglePages === '1' ? true : false

      Object.assign(IssueData, locIssueData)

      // Check if pages all have .background 
      // if not, then set $readerOptions.useBitmapPages to false
      if (this.$readerOptions.useBitmapPages) {
        for (let i = 0; i < pages.length; i++) {
          if (pages[i].firstPage.background === null) {
            this.$readerOptions.useBitmapPages = false
            this.$injectPdfJSLibrary(this.$store)
            break
          }
        }
      }
      
      this.$store.commit('setSinglePagesNoAds', singlePages)
      this.$store.commit('setPages', pages)
      this.$store.commit('setSections', sections)
      this.$store.commit('setArticles', articles)      
      this.$store.commit('setInterstitials', interstitials)
      this.$store.state.ads = ads

      this.setFontSizeFromStylesheet()

      CciDataSourceClearMemory()

      this.$cciEventTrackingPlugin.setApp(this)
      this.$cciEventTrackingPlugin.setIssueData(IssueData)
      this.$cciEventTrackingPlugin.trackEvent('WebreaderApp', 'IssueLoaded')
    }).catch(error => {
      console.log('ERROR', error)
      this.routeTo('error', { message: error })
    })
  },
  computed: {
    showSectionsBar: function () {
      return (this.$readerOptions.enableSectionsBar) &&
      this.sections.length > 1 &&
      this.$route.name !== 'articles-mobile' &&
      this.$route.name !== 'article-mobile' &&
      this.$route.name !== 'articles'
    },
    showGptAdModuleBottom: function () {
      return this.$route.name === 'pages' &&
      IssueData.gptAdsEnabled &&
      this.initPageLoaded &&
      !this.isDesktop
    },
    showGptAdModuleSide: function () {
      // load the ad on the left after the first page has loaded.
      return this.$route.name === 'pages' &&
      IssueData.gptAdsEnabled &&
      this.initPageLoaded &&
      this.isDesktop
    },
    showRightAlignedBar () {
      return this.isVerticalLayout && !this.showImageGalleryModal
      // if (this.options !== undefined && this.isVerticalLayout && !this.showImageGalleryModal) {
      //   if (this.isDesktop || this.isTabletLandscape) {
      //     return true
      //   } else if (this.isPhone) {
      //     if (this.isZoomed) {
      //       return this.showArticleModal
      //     }
      //     return true
      //   } else if (this.isTabletPortrait) {
      //     if (this.isZoomed) {
      //       return false
      //     }
      //     return !this.showArticleModal
      //   }
      // }
      // return false
    },
    showLeftAlignedScrubber () {
      return this.isVerticalLayout && this.$readerOptions.enableScrubber
    },
    ...mapGetters({
      showScrubber: 'getShowScrubber',
      showIssueOverview: 'getShowIssueOverview',
      printAndDownload: 'getPrintAndDownload',
      showArticleModal: 'getShowArticleModal',
      showSharing: 'getShowSharing',
      showImageGalleryModal: 'getShowImageGalleryModal',
      showCrop: 'getShowCrop',
      showRightAlignedNavigationBar: 'getShowRightAlignedNavigationBar',
      currentPage: 'getCurrentPage',
      currentArticle: 'getCurrentArticle',
      // startPage: 'getStartPage',
      sections: 'getSections',
      isZoomAnimating: 'getIsZoomAnimating',
      // token: 'getToken',
      initPageLoaded: 'getInitPageLoaded',
      zoomedPages: 'getZoomedPages',
      showCropMenu: 'getShowCropMenu',
      showPrintMenu: 'getShowPrintMenu'
    })
  },
  watch: {
    zoomedPages: {
      handler (newValue) {
        this.isZoomed = newValue.indexOf(this.currentPage) !== -1
      }, 
      deep: true      
    },
    showArticleModal (newValue) {
      this.updateTabIndexesForModalOnPages(newValue)
    },
    showIssueOverview (newValue) {
      this.updateTabIndexesForModalOnPages(newValue)
    },
    showSharing (newValue) {
      if (this.$route.name === 'articles' || this.$route.name === 'article-mobile') {
        this.updateTabIndexesForModalOnArticleList(newValue)
      }
      if (this.$route.name === 'pages') {
        this.updateTabIndexesForModalOnArticleModal(newValue)
      }
    }, 
    showImageGalleryModal (newValue) {
      if (this.$route.name === 'articles' || this.$route.name === 'article-mobile') {
        this.updateTabIndexesForModalOnArticleList(newValue)
      }
      if (this.$route.name === 'pages') {
        this.updateTabIndexesForModalOnArticleModal(newValue)
      }
    },
    '$route': function () {
      this.$store.commit('setShowBurgerMenu', false)
    }
  },
  methods: {
    closeNavigations (event) {
      // Close side menu if visible
      let burgerButton = document.getElementById('burger-button')
      let slider = document.getElementById('nav-right-pages') ? document.getElementById('nav-right-pages') : document.getElementById('nav-right-article-list')
      if (slider !== null && slider !== undefined && slider !== event.target && burgerButton !== null && burgerButton !== undefined && burgerButton !== event.target && !slider.contains(event.target) && !burgerButton.contains(event.target)) {
        this.$store.commit('setShowBurgerMenu', false)
      }

      let scrubberContainer = document.getElementsByClassName('scrubber')[0]
      let scrubberButton = document.getElementById('nav-scrubber-button')
      const rightBarScrubberButton = document.getElementsByClassName('right-navigation-bar-item-scrubber')[0]
      // if the target of the click isn't the container or the scrubber button...
      // ... nor a descendant of the container
      if (event.composedPath().indexOf(scrubberButton) === -1 && 
        event.composedPath().indexOf(scrubberContainer) === -1 && 
        event.composedPath().indexOf(rightBarScrubberButton) === -1) {
        if (this.showScrubber) {
          this.$store.commit('toggleScrubberVisible')
        }
      }

      let cropperContainer = document.getElementsByClassName('cropper-container')[0]
      let cropButton = document.getElementById('cropMenu')
      if (event.composedPath().indexOf(cropperContainer) === -1 && event.composedPath().indexOf(cropButton) === -1 && this.showCrop && !this.isVerticalLayout) {
        this.$store.commit('setCropVisible', false)
      }

      const rightBarContainer = document.getElementsByClassName('right-navigation-bar-container')[0]
      if (event.composedPath().indexOf(rightBarContainer) === -1 && this.showRightAlignedNavigationBar) {
        this.$store.commit('setShowRightAlignedNavigationBar', false)
      }

      const leftScrubber = document.getElementById('left-scrubber-container')
      const leftScrubberBut = document.getElementById('left-scrubber-phone-button')
      if (leftScrubber !== null && event.composedPath().indexOf(leftScrubber) === -1 && event.composedPath().indexOf(leftScrubberBut) === -1 && leftScrubber.offsetWidth > 0) {
        this.$store.commit('setShowLeftAlignedScrubber', false)
      }

      const menus = document.getElementsByClassName('select-page-menu')
      const printButton = document.getElementById('printMenu')
      if (menus.length > 0) {
        for (let i = 0; i < menus.length; i++) {
          if (event.composedPath().indexOf(menus[i]) === -1) {
            if (event.composedPath().indexOf(cropButton) === -1) {
              this.$store.commit('setShowCropMenu', false)
            }
            if (event.composedPath().indexOf(printButton) === -1) {
              this.$store.commit('setShowPrintMenu', false)
            }
          }
        }
      }
    },
    getIndexForPageFromRouteParam(pageParam) {
      for (var i = 0; i < this.$store.state.pages.length; i++) {
        if (this.$store.state.pages[i].firstPage.pageNumber === pageParam) {
          return i
        } else if (this.$store.state.pages[i].secondPage !== null && this.$store.state.pages[i].secondPage.pageNumber === pageParam) {
          return i
        }
      }
    },
    setFontSizeFromStylesheet() {
      if (stylesheetRef) {
        let stylesheetUrl = this.$opsURL + stylesheetRef
        fetch(stylesheetUrl).then((response) => {
          if (!response.ok) {
            throw new Error(response.status + ' - Network response was not ok. ' + response.statusText + ' Please try again later')
          }
          return response.text()
        }).then(cssdata => {
          var doc = document.implementation.createHTMLDocument(""),
          styleElement = document.createElement("style")
          styleElement.textContent = cssdata
          // the style will only be parsed once it is added to a document
          doc.body.appendChild(styleElement)
          let rules = styleElement.sheet.cssRules
          for (var i = 0; i < rules.length; i++) {
            if (rules[i].selectorText === 'html') {
              let fontSizeStr = rules[i].style.fontSize
              let fontSize = fontSizeStr.match(/\d+/)[0]
              this.$store.state.articleFontsize = Number(fontSize)
              this.$store.state.articleFontSizeUnit = fontSizeStr.replace(fontSize, '')
              break
            }
          }
        }).catch(error => {
          console.log('Stylesheet ERROR', error)
        })
      }
    },
    // orientationDidChange () {
      // if (this.$route.name === 'article-mobile' || this.$route.name === 'articles-mobile') {
      //   let articleNumber = this.$store.state.articles.indexOf(this.currentArticle).toString()
      //   this.$router.push({
      //     name: 'articles',
      //     params: { articleNr: articleNumber }
      //   })
      // } else if (this.$route.name === 'articles') {
      //   this.$router.push({
      //     name: 'articles-mobile'
      //   })
      // }
    // },
    pageChildObj () {
      if (this.$route.name !== "pages") {
        return this.$store.state.currentArticle
      }
      return this.$store.state.selectedPageChild
    },
    updateTabIndexesForModalOnPages (show) {
      const slides = document.getElementsByClassName('section-swiper-slide');
      for (let i = 0; i < slides.length; i++) {
        if (!show) {
          slides[i].setAttribute('tabindex', 0);
          slides[i].removeAttribute('aria-hidden');
        } else {
          slides[i].setAttribute('tabindex', -1);
          slides[i].setAttribute('aria-hidden', 'true');
        }
      }
      const navIcons = document.getElementsByClassName('nav-button')
      for (let i = 0; i < navIcons.length; i++) {
        const isDisabled = navIcons[i].attributes.getNamedItem('aria-disabled') !== null ? navIcons[i].attributes.getNamedItem('aria-disabled').value : 'false';
        if (!show && isDisabled === 'false') {
          navIcons[i].setAttribute('tabindex', 0);
          navIcons[i].removeAttribute('aria-hidden');
        } else {
          navIcons[i].setAttribute('tabindex', -1);
          navIcons[i].setAttribute('aria-hidden', 'true');
        }
      }
      const pageNav = document.getElementsByClassName('page-nav-button')
      for (let i = 0; i < pageNav.length; i++) {
        if (!show) {
          pageNav[i].setAttribute('tabindex', 0);
          pageNav[i].removeAttribute('aria-hidden');
        } else {
          pageNav[i].setAttribute('tabindex', -1);
          pageNav[i].setAttribute('aria-hidden', 'true');
        }
      }

      const skipLinks = document.getElementsByClassName('skip-link');
      for (let i = 0; i < skipLinks.length; i++) {
        if (skipLinks[i].id === 'skip-to-main-link') {
          continue
        }
        if (!show) {
          skipLinks[i].setAttribute('tabindex', 0);
          skipLinks[i].removeAttribute('aria-hidden');
        } else {
          skipLinks[i].setAttribute('tabindex', -1);
          skipLinks[i].setAttribute('aria-hidden', 'true');
        }
      }

      const sectionNavs = document.getElementsByClassName('section-nav-button');
      for (let i = 0; i < sectionNavs.length; i++) {
        if (!show) {
          sectionNavs[i].setAttribute('tabindex', 0);
          sectionNavs[i].removeAttribute('aria-hidden');
        } else {
          sectionNavs[i].setAttribute('tabindex', -1);
          sectionNavs[i].setAttribute('aria-hidden', 'true');
        }
      }

      const burgerButton = document.getElementById('burger-button')
      if (burgerButton !== null && burgerButton !== undefined) {
        if (!show) {
          burgerButton.setAttribute('tabindex', 0);
          burgerButton.removeAttribute('aria-hidden');
        } else {
          burgerButton.setAttribute('tabindex', -1);
          burgerButton.setAttribute('aria-hidden', 'true');
        }
      }
    },
    updateTabIndexesForModalOnArticleModal (show) {
      const articleNav = document.getElementsByClassName('article-nav-button')
      for (let i = 0; i < articleNav.length; i++) {
        const isDisabled = articleNav[i].attributes.getNamedItem('aria-disabled') !== null ? articleNav[i].attributes.getNamedItem('aria-disabled').value : 'false';
        if (!show && isDisabled === 'false') {
          articleNav[i].setAttribute('tabindex', 0);
          articleNav[i].removeAttribute('aria-hidden');
        } else {
          articleNav[i].setAttribute('tabindex', -1);
          articleNav[i].setAttribute('aria-hidden', 'true');
        }
      }

      const closeButt = document.getElementsByClassName('article-modal-close-button');
      for (let i = 0; i < closeButt.length; i++) {
        if (!show) {
          closeButt[i].setAttribute('tabindex', 0);
          closeButt[i].removeAttribute('aria-hidden');
        } else {
          closeButt[i].setAttribute('tabindex', -1);
          closeButt[i].setAttribute('aria-hidden', 'true');
        }
      }

      const articleContents = document.getElementsByClassName('article-contents');
      for (let i = 0; i < articleContents.length; i++) {
        if (!show) {
          articleContents[i].setAttribute('tabindex', 0);
          articleContents[i].removeAttribute('aria-hidden');
        } else {
          articleContents[i].setAttribute('tabindex', -1);
          articleContents[i].setAttribute('aria-hidden', 'true');
        }
      }

      const articleContentsImg = document.getElementsByClassName('article-contents-img');
      for (let i = 0; i < articleContentsImg.length; i++) {
        if (!show) {
          articleContentsImg[i].setAttribute('tabindex', 0);
          articleContentsImg[i].removeAttribute('aria-hidden');
        } else {
          articleContentsImg[i].setAttribute('tabindex', -1);
          articleContentsImg[i].setAttribute('aria-hidden', 'true');
        }
      }

      const articleButtons = document.getElementsByClassName('article-nav-button');
      for (let i = 0; i < articleButtons.length; i++) {
        if (!show) {
          articleButtons[i].setAttribute('tabindex', 0);
          articleButtons[i].removeAttribute('aria-hidden');
        } else {
          articleButtons[i].setAttribute('tabindex', -1);
          articleButtons[i].setAttribute('aria-hidden', 'true');
        }
      }
    },
    updateTabIndexesForModalOnArticleList (show) {
      // Opening social sharing modal should disable tabbing to other elements.
      // article list elements
      const navIcons = document.getElementsByClassName('nav-button')
      for (let i = 0; i < navIcons.length; i++) {
        const isDisabled = navIcons[i].attributes.getNamedItem('aria-disabled') !== null ? navIcons[i].attributes.getNamedItem('aria-disabled').value : 'false';
        if (!show && isDisabled === 'false') {
          navIcons[i].setAttribute('tabindex', 0);
          navIcons[i].removeAttribute('aria-hidden');
        } else {
          navIcons[i].setAttribute('tabindex', -1);
          navIcons[i].setAttribute('aria-hidden', 'true');
        }
      }

      const articleListItems = document.getElementsByClassName('article-list-item');
      for (let i = 0; i < articleListItems.length; i++) {
        if (!show) {
          articleListItems[i].setAttribute('tabindex', 0);
          articleListItems[i].removeAttribute('aria-hidden');
        } else {
          articleListItems[i].setAttribute('tabindex', -1);
          articleListItems[i].setAttribute('aria-hidden', 'true');
        }
      }

      const pageThumbnail = document.getElementsByClassName('page-thumbnail');
      for (let i = 0; i < pageThumbnail.length; i++) {
        if (!show) {
          pageThumbnail[i].setAttribute('tabindex', 0);
          pageThumbnail[i].removeAttribute('aria-hidden');
        } else {
          pageThumbnail[i].setAttribute('tabindex', -1);
          pageThumbnail[i].setAttribute('aria-hidden', 'true');
        }
      }

      const articleNav = document.getElementsByClassName('article-nav-button')
      for (let i = 0; i < articleNav.length; i++) {
        const isDisabled = articleNav[i].attributes.getNamedItem('aria-disabled') !== null ? articleNav[i].attributes.getNamedItem('aria-disabled').value : 'false';
        if (!show && isDisabled === 'false') {
          articleNav[i].setAttribute('tabindex', 0);
          articleNav[i].removeAttribute('aria-hidden');
        } else {
          articleNav[i].setAttribute('tabindex', -1);
          articleNav[i].setAttribute('aria-hidden', 'true');
        }
      }

      const articleContents = document.getElementsByClassName('article-contents');
      for (let i = 0; i < articleContents.length; i++) {
        if (!show) {
          articleContents[i].setAttribute('tabindex', 0);
          articleContents[i].removeAttribute('aria-hidden');
        } else {
          articleContents[i].setAttribute('tabindex', -1);
          articleContents[i].setAttribute('aria-hidden', 'true');
        }
      }

      const articleContentsImg = document.getElementsByClassName('article-contents-img');
      for (let i = 0; i < articleContentsImg.length; i++) {
        if (!show) {
          articleContentsImg[i].setAttribute('tabindex', 0);
          articleContentsImg[i].removeAttribute('aria-hidden');
        } else {
          articleContentsImg[i].setAttribute('tabindex', -1);
          articleContentsImg[i].setAttribute('aria-hidden', 'true');
        }
      }

      const listContainer = document.getElementsByClassName('list-container');
      for (let i = 0; i < listContainer.length; i++) {
        if (!show) {
          listContainer[i].setAttribute('tabindex', 0);
          listContainer[i].removeAttribute('aria-hidden');
        } else {
          listContainer[i].setAttribute('tabindex', -1);
          listContainer[i].setAttribute('aria-hidden', 'true');
        }
      }

      const jumpButton = document.getElementById('jump-button')
      if (jumpButton !== null && jumpButton !== undefined) {
        if (!show) {
          jumpButton.setAttribute('tabindex', 0);
          jumpButton.removeAttribute('aria-hidden');
        } else {
          jumpButton.setAttribute('tabindex', -1);
          jumpButton.setAttribute('aria-hidden', 'true');
        }
      }

      const burgerButton = document.getElementById('burger-button')
      if (burgerButton !== null && burgerButton !== undefined) {
        if (!show) {
          burgerButton.setAttribute('tabindex', 0);
          burgerButton.removeAttribute('aria-hidden');
        } else {
          burgerButton.setAttribute('tabindex', -1);
          burgerButton.setAttribute('aria-hidden', 'true');
        }
      }
    },
    loadStartRoute () {
        // default is to start at page 1
      let routeName = "pages";
      // set the route param to the start page
      let routeParam = { pageNr: this.$readerOptions.startPage.toString() };

      // If the routerMode is hash, then we check the hash to see if we should start at a different page.
      const url = new URL(window.location.href);
      if (url.hash.indexOf("#") !== -1 && this.$readerOptions.routerMode === "hash") {
        // If the hash has a value, then we set the route param to the hash value.
        if (
          url.hash.split("#/")[1] !== undefined &&
          url.hash.split("#/")[1] !== ""
        ) {
          // set the route name to the hash value
          routeName = url.hash.split("#/")[1].split("/")[0];

          // get the route param from the hash value
          const routeParamNr = url.hash.split("#/")[1].split("/")[1];
          if (routeParamNr !== undefined) {
            // if the route name is pages, then we set the pageNr to the route param
            if (routeName === "pages") {
              routeParam = { pageNr: routeParamNr };
            } else if (routeName === "articles" || routeName === "article-mobile") {
              // if the route name is articles or article-mobile, then we set the articleNr to the route param
              routeParam = { articleNr: routeParamNr };
            }
          }
        }
      }
      this.routeTo(routeName, routeParam);
    }
  },
  components: {
    CciNavigationBar,
    CciSectionsBar,
    CciIssueOverview,
    CciArticleModal,
    CciSocialSharing,
    CciScrubber,
    CciGoogleAdBottomMobile,
    CciGoogleAdSide,
    CciImageGalleryModal,
    CciRightAlignedNavigationBar,
    CciLeftAlignedScrubber
  },
  beforeUnmount () {
    document.getElementById('webreader-app').removeEventListener('click', this.closeNavigations)

    // if route mode is hash, then we set the hash to the default page
    if (this.$readerOptions.routerMode === "hash") {
      window.location.hash = "#/pages/1";
    }

    // close all modals
    this.$store.commit('setShowArticleModal', false)
    this.$store.commit('setShowSharing', false)
    this.$store.commit('setShowImageGalleryModal', false)
    this.$store.commit('setShowRightAlignedNavigationBar', false)
    this.$store.commit('setShowLeftAlignedScrubber', false)
    this.$store.commit('setScrubberVisibile', false)
    this.$store.commit('setShowIssueOverview', false)
    this.$store.commit('setShowPrintDownloadConsent', false)

    // make sure the store is cleared
    this.$store.commit('setPages', [])
    this.$store.commit('setSections', [])
    this.$store.commit('setArticles', [])
    this.$store.commit('setInterstitials', undefined)
    this.$store.commit('setSinglePagesNoAds', [])
  },
  unmounted () {
    // Call the unmount callback if it exists
    if (this.$unmountCallback && typeof this.$unmountCallback === 'function') {
      this.$unmountCallback()
    }
  }
}
